// tslint:disable-next-line:no-reference
/// <reference path="../../../../Cloud.RavenDB.Web.TypingsGenerator/typings/server/include.ts" />

import { createContext, useContext, useEffect, useState } from "react";
import PortalConfigurationDto = Cloud.RavenDB.Core.Dto.PortalConfigurationDto;
import * as React from "react";
import { Loading } from "@commonComponents/ui/Loading";
import { useServices } from "./useServices";

interface PortalConfigurationHook {
    configuration: PortalConfigurationDto;
}

const configurationContext = createContext<PortalConfigurationHook>(undefined);

export function ProvideConfiguration({
    children,
    overrideConfiguration,
}: {
    overrideConfiguration?: PortalConfigurationDto;
    children: JSX.Element;
}) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const configuration = overrideConfiguration ? { configuration: overrideConfiguration } : useProvideConfiguration();
    if (configuration.configuration) {
        return <configurationContext.Provider value={configuration}>{children}</configurationContext.Provider>;
    } else {
        return <Loading />;
    }
}

function useProvideConfiguration(): PortalConfigurationHook {
    const { configurationService } = useServices();
    const [configuration, setConfiguration] = useState<PortalConfigurationDto>();

    useEffect(() => {
        async function fetch() {
            const config = await configurationService.getConfiguration();
            setConfiguration(config);
        }

        // noinspection JSIgnoredPromiseFromCall
        fetch();
    }, [configurationService, setConfiguration]);

    return {
        configuration,
    };
}

export function useConfiguration() {
    return useContext(configurationContext);
}
